import React, { Suspense, ReactNode } from 'react';
import { ErrorBoundary } from '@/components/error/ErrorBoundary';

interface SafeChartProps {
  children: ReactNode;
  height?: string;
}

/**
 * SafeChart wraps recharts components in an ErrorBoundary + Suspense boundary.
 * This isolates recharts' internal hook violations (React Error #310) so they
 * only tear down the chart, not the entire page.
 */
export function SafeChart({ children, height = '100%' }: SafeChartProps) {
  return (
    <ErrorBoundary
      fallback={
        <div
          className="flex items-center justify-center bg-muted/30 rounded-lg text-sm text-muted-foreground"
          style={{ height, minHeight: '120px' }}
        >
          Chart unavailable
        </div>
      }
    >
      <Suspense
        fallback={
          <div
            className="animate-pulse bg-muted rounded-lg"
            style={{ height, minHeight: '120px' }}
          />
        }
      >
        {children}
      </Suspense>
    </ErrorBoundary>
  );
}
